import { render, staticRenderFns } from "./AddDependentsModalContainer.vue?vue&type=template&id=198da15c&lang=pug&"
import script from "./AddDependentsModalContainer.vue?vue&type=script&lang=js&"
export * from "./AddDependentsModalContainer.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentsModalContainer.vue?vue&type=style&index=0&id=198da15c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports